import ShoppingList from './ShoppingList.jsx'

export default ShoppingList
